import {
  ACQ_SRC_LIST,
  ADMIN_ROLES,
  BANK_NAME_LIST,
  BUISNESS_TYPE_LIST,
  CATEGORY_LIST,
  CUSTOMER_LIST,
  DEPARTMENR_LIST,
  DIS_CUS_GROUP_LIST,
  DIS_CUS_CAT_LIST,
  DIS_CUS_TYPE_LIST,
  DIS_CUS_LIST,
  DOCTOR_LIST,
  IMAGE_UPLOAD,
  ITEM_GROUP_LIST,
  MANUFACTURERS_LIST,
  PAYMENT_METHODS_LIST,
  PHONE_LIST,
  PRICE_LIST,
  PRODUCT_LIST,
  ROLES_LIST,
  ATTACHED_ROLES_DEPARTMENT_LIST,
  SCH_LIST,
  SECTOR_LIST,
  SHIPPING_TYPE_LIST,
  STATE_LIST,
  STORE_ID,
  TAX_CAT_LIST,
  UOM_GROUP_FIND_ONE,
  UOM_GROUP_LIST,
  UOM_LIST,
  USERS_LIST,
  VALUATION_LIST,
  VENDOR_LIST,
  PINCODE_LIST,
  GST_SEARCH_TAXPAYER,
  MANUFACTURER_FUZZY_SEARCH,
  BIN_LOCATION_LIST,
  DEFAULT_BIN_LOCATION,
  SEARCH_BIN_LOCATION,
  WARE_HOUSE_LIST,
  CUSTOMER_TYPE_LIST,
  ITEM_TYPE_DROP_DOWN,
  TRANSACTION_SHARE,
  TRANSACTION_PRINT,
  STORE_LIST,
  PRODUCT_DETAILS,
  DOC_LIST,
  ADMIN_ROLES_MOD,
  PRODUCT_BATCH_DETAILS,
  STORE_CITY_LIST,
  STORE_DISTRICT_LIST,
  STORE_STATE_LIST,
  STORE_SEARCH,
  STORE_ITEM,
  TABLE_ALERT,
  COLUMN_ALERT,
  ALL_USERS_LIST,
  GET_ADDRSS,
  WARE_HOUSE_LIST_NEW,
  INTER_TAX_CAT_LIST,
} from "../types";

export const getAddress = (data, onSuccess, onError) => {
  return {
    type: GET_ADDRSS,
    data,
    onSuccess,
    onError,
  };
};

export const productListAction = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const producDetailsAction = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_DETAILS,
    data,
    onSuccess,
    onError,
  };
};
export const producBatchDetailsAction = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_BATCH_DETAILS,
    data,
    onSuccess,
    onError,
  };
};
export const phoneListAction = (data, onSuccess, onError) => {
  return {
    type: PHONE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const stateListAction = (onSuccess, onError) => {
  return {
    type: STATE_LIST,
    onSuccess,
    onError,
  };
};

export const doctorListAction = (onSuccess, onError) => {
  return {
    type: DOCTOR_LIST,
    onSuccess,
    onError,
  };
};
export const storeIdAction = (onSuccess, onError) => {
  return {
    type: STORE_ID,
    onSuccess,
    onError,
  };
};
export const paymentMethodListAction = (onSuccess, onError) => {
  return {
    type: PAYMENT_METHODS_LIST,
    onSuccess,
    onError,
  };
};
export const tableAlertAction = (data, onSuccess, onError) => {
  return {
    type: TABLE_ALERT,
    data,
    onSuccess,
    onError,
  };
};
export const allUsersList = (onSuccess, onError) => {
  return {
    type: ALL_USERS_LIST,

    onSuccess,
    onError,
  };
};

export const columnAlertAction = (data, onSuccess, onError) => {
  return {
    type: COLUMN_ALERT,
    data,
    onSuccess,
    onError,
  };
};
export const catListAction = (onSuccess, onError) => {
  return {
    type: CATEGORY_LIST,
    onSuccess,
    onError,
  };
};
export const uomListAction = (onSuccess, onError) => {
  return {
    type: UOM_LIST,
    onSuccess,
    onError,
  };
};
export const priceListAction = (onSuccess, onError) => {
  return {
    type: PRICE_LIST,
    onSuccess,
    onError,
  };
};
export const itemGroupListAction = (onSuccess, onError) => {
  return {
    type: ITEM_GROUP_LIST,
    onSuccess,
    onError,
  };
};
export const itemTypeListAction = (onSuccess, onError) => {
  return {
    type: ITEM_TYPE_DROP_DOWN,
    onSuccess,
    onError,
  };
};
export const taxCatListAction = (onSuccess, onError) => {
  return {
    type: TAX_CAT_LIST,
    onSuccess,
    onError,
  };
};
export const interTaxCatListAction = (onSuccess, onError) => {
  return {
    type: INTER_TAX_CAT_LIST,
    onSuccess,
    onError,
  };
};
export const manufacturesListAction = (onSuccess, onError) => {
  return {
    type: MANUFACTURERS_LIST,
    onSuccess,
    onError,
  };
};
export const shippingTypeListAction = (onSuccess, onError) => {
  return {
    type: SHIPPING_TYPE_LIST,
    onSuccess,
    onError,
  };
};
export const sectorListAction = (onSuccess, onError) => {
  return {
    type: SECTOR_LIST,
    onSuccess,
    onError,
  };
};
export const schListAction = (onSuccess, onError) => {
  return {
    type: SCH_LIST,
    onSuccess,
    onError,
  };
};
export const vendorListAction = (onSuccess, onError) => {
  return {
    type: VENDOR_LIST,
    onSuccess,
    onError,
  };
};
export const valListAction = (onSuccess, onError) => {
  return {
    type: VALUATION_LIST,
    onSuccess,
    onError,
  };
};

export const uomGroupListAction = (onSuccess, onError) => {
  return {
    type: UOM_GROUP_LIST,
    onSuccess,
    onError,
  };
};
export const uomGroupFindOneAction = (data, onSuccess, onError) => {
  return {
    type: UOM_GROUP_FIND_ONE,
    data,
    onSuccess,
    onError,
  };
};
export const imageUploadAction = (data, onSuccess, onError) => {
  return {
    type: IMAGE_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
export const adminRolesAction = (onSuccess, onError) => {
  return {
    type: ADMIN_ROLES,
    onSuccess,
    onError,
  };
};
export const adminRolesModAction = (onSuccess, onError) => {
  return {
    type: ADMIN_ROLES_MOD,
    onSuccess,
    onError,
  };
};
export const departmentListAction = (onSuccess, onError) => {
  return {
    type: DEPARTMENR_LIST,
    onSuccess,
    onError,
  };
};
export const RolesListAction = (onSuccess, onError) => {
  return {
    type: ROLES_LIST,
    onSuccess,
    onError,
  };
};

export const attachedRolesDepartmentListAction = (data, onSuccess, onError) => {
  return {
    type: ATTACHED_ROLES_DEPARTMENT_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const DocListAction = (onSuccess, onError) => {
  return {
    type: DOC_LIST,
    onSuccess,
    onError,
  };
};

export const UsersListAction = (data, onSuccess, onError) => {
  return {
    type: USERS_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const cusTypeListAction = (onSuccess, onError) => {
  return {
    type: CUSTOMER_TYPE_LIST,
    onSuccess,
    onError,
  };
};
export const disCusListAction = (onSuccess, onError) => {
  return {
    type: DIS_CUS_LIST,
    onSuccess,
    onError,
  };
};

export const acqSrcListAction = (onSuccess, onError) => {
  return {
    type: ACQ_SRC_LIST,
    onSuccess,
    onError,
  };
};
export const buisnessTypeListAction = (onSuccess, onError) => {
  return {
    type: BUISNESS_TYPE_LIST,
    onSuccess,
    onError,
  };
};
export const bnkNameListAction = (onSuccess, onError) => {
  return {
    type: BANK_NAME_LIST,
    onSuccess,
    onError,
  };
};

export const disCusGrpListAction = (onSuccess, onError) => {
  return {
    type: DIS_CUS_GROUP_LIST,
    onSuccess,
    onError,
  };
};

export const disCusCatListAction = (onSuccess, onError) => {
  return {
    type: DIS_CUS_CAT_LIST,
    onSuccess,
    onError,
  };
};

export const disCusTypeListAction = (onSuccess, onError) => {
  return {
    type: DIS_CUS_TYPE_LIST,
    onSuccess,
    onError,
  };
};

export const customerListAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOMER_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const pincodeListAction = (data, onSuccess, onError) => {
  return {
    type: PINCODE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const gstSearchTaxpayerAction = (data, onSuccess, onError) => {
  return {
    type: GST_SEARCH_TAXPAYER,
    data,
    onSuccess,
    onError,
  };
};

export const manufacturerFuzzySearchAction = (data, onSuccess, onError) => {
  return {
    type: MANUFACTURER_FUZZY_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const binLocationListAction = (onSuccess, onError) => {
  return {
    type: BIN_LOCATION_LIST,
    onSuccess,
    onError,
  };
};
export const defaultBinLocationAction = (data, onSuccess, onError) => {
  return {
    type: DEFAULT_BIN_LOCATION,
    data,
    onSuccess,
    onError,
  };
};
export const searchBinLocationAction = (data, onSuccess, onError) => {
  return {
    type: SEARCH_BIN_LOCATION,
    data,
    onSuccess,
    onError,
  };
};
export const wareHouseListAction = (onSuccess, onError) => {
  return {
    type: WARE_HOUSE_LIST,
    onSuccess,
    onError,
  };
};
export const newWareHouseListAction = (onSuccess, onError) => {
  return {
    type: WARE_HOUSE_LIST_NEW,
    onSuccess,
    onError,
  };
};
export const storeListAction = (onSuccess, onError) => {
  return {
    type: STORE_LIST,
    onSuccess,
    onError,
  };
};

export const transactionShareAction = (data, onSuccess, onError) => {
  return {
    type: TRANSACTION_SHARE,
    data,
    onSuccess,
    onError,
  };
};
export const transactionPrintAction = (data, onSuccess, onError) => {
  return {
    type: TRANSACTION_PRINT,
    data,
    onSuccess,
    onError,
  };
};

export const storeStateListAction = (onSuccess, onError) => {
  return {
    type: STORE_STATE_LIST,
    onSuccess,
    onError,
  };
};
export const storeDistrictListAction = (data, onSuccess, onError) => {
  return {
    type: STORE_DISTRICT_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const storeCityListAction = (data, onSuccess, onError) => {
  return {
    type: STORE_CITY_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const storeSearchAction = (data, onSuccess, onError) => {
  return {
    type: STORE_SEARCH,
    data,
    onSuccess,
    onError,
  };
};
export const storesItemAction = (data, onSuccess, onError) => {
  return {
    type: STORE_ITEM,
    data,
    onSuccess,
    onError,
  };
};
